'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var getAxiosError = function getAxiosError(error) {
  if (error.response) {
    return error.response;
  }

  return {
    message: error.message
  };
};

exports["default"] = getAxiosError;
